export default {
  name: "Shipping",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "m29.87 17.98-2.69-7.18a2 2 0 0 0-1.87-1.3H21v-5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v21c0 1.1.9 2 2 2h2.35c.56 1.18 1.76 2 3.15 2s2.59-.82 3.15-2h6.7c.56 1.18 1.76 2 3.15 2s2.58-.82 3.15-2H28c1.1 0 2-.9 2-2v-6.82c0-.24-.04-.48-.13-.7zM19 4.5v15H4v-15h15zm-9.5 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5.5-2h-2.05c-.25-1.69-1.69-3-3.45-3s-3.2 1.31-3.45 3h-6.1c-.24-1.69-1.69-3-3.45-3s-3.2 1.31-3.45 3H4v-4h15c1.1 0 2-.9 2-2v-8h4.31L28 18.68v6.82z",
  },
}
